import React, { useState } from "react";
import { ReactComponent as Menu } from "../../img/Menu.svg";
import { MenuContent, MenuLineButton, MenuWrapper } from "./style/utils.style";

const FloatingMenu = (props) => {
	const [showMenu, setShowMenu] = useState(false);

	const openMenu = () => {
		setShowMenu(true);
	};

	const closeMenu = (e) => {
		// close menu when click outside self an children
		if (e.currentTarget.contains(e.relatedTarget)) {
			// clicking on self or children doesn't close menu
		} else if (e.currentTarget === e.target && !e.currentTarget.contains(e.relatedTarget)) {
			setShowMenu(false);
		} else {
			setShowMenu(false);
		}
	};

	const renderOptions = () => {
		return props?.options.map((option, index) => {
			return (
				<MenuLineButton type="button" value={props.rowCode} key={index} onClick={() => option.action(props.rowCode)}>
					{option.label}
				</MenuLineButton>
			);
		});
	};
	if (props.options) {
		return (
			<MenuWrapper id={props.rowId} show={showMenu} tabIndex={props.rowId} onFocus={openMenu} onBlur={closeMenu}>
				{props.children}
				{props.icon ? props.icon : <Menu />}
				<MenuContent show={showMenu}>{renderOptions()}</MenuContent>
			</MenuWrapper>
		);
	} else return null;
};
export default FloatingMenu;
